/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getNormativasClienteNoEnviadasPaginado, importacionMasivaDocumentos } from "../../../componentes/http/actions/DocumentoAction";
import { getClientesUsuario } from "../../../componentes/http/actions/UsuarioAction";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TablePagination,
  useMediaQuery,
  useTheme,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Autocomplete,
  Checkbox,
  Chip,
  Alert,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { jwtDecode } from "jwt-decode";
import SendIcon from '@mui/icons-material/Send';
import ClearIcon from '@mui/icons-material/Clear';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DataLoaderCliente from "../../../componentes/data/DataLoaderCliente";
import LogoGRC from "../../../assets/Austranet-GRC_titulo.png" ;

const IntegracionGRCNormativas = () => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const idUsuario = decoded["oid"];
  
  // Estados para datos y UI
  const [serviciosDisponibles, setServiciosDisponibles] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [isLoadingNormativas, setIsLoadingNormativas] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const [urlGrcFront, setUrlGrcFront] = useState(null);
  
  // Estados para selección
  const [selectedNormativas, setSelectedNormativas] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  
  // Estados para envío
  const [isSending, setIsSending] = useState(false);
  const [sendSuccess, setSendSuccess] = useState(false);
  const [sendError, setSendError] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  
  // Estados para paginación
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Estados para filtros
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCliente, setFilterCliente] = useState("todos");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  
  // Estados para opciones de filtros
  const [clientes, setClientes] = useState([]);
  const [multipleClients, setMultipleClients] = useState(false);
  const [selectedClienteId, setSelectedClienteId] = useState(null);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const [loadedData, setLoadedData] = useState({
    organismos: [],
    tiposDocumento: [],
    estadosTramitacion: [],
    rubros: [],
  });

  const [selectedFilters, setSelectedFilters] = useState({
    organismo: null,
    tipoDocumento: null,
    estadoTramitacion: null,
    rubro: null,
  });

  const handleDataLoaded = useCallback((data) => {
    setLoadedData(data);
  }, []);

  // Obtener inicialmente la data
  useEffect(() => {
    fetchClientes();
    fetchNormativasPaginadas();
  }, []);
  
  useEffect(() => {
    setMultipleClients(clientes && clientes.length > 1);
  }, [clientes]);

  // Establecer cliente por defecto
  useEffect(() => {
    if (clientes && clientes.length > 0 && !selectedClienteId) {
      setSelectedClienteId(clientes[0].id);

      if (clientes[0].urlGrcFront) {
        setUrlGrcFront(clientes[0].urlGrcFront);
      }
      const serviciosUnicos = clientes.reduce((servicios, cliente) => {
          if (cliente.servicios && Array.isArray(cliente.servicios)) {
            cliente.servicios.forEach(servicio => {
              if (!servicios.includes(servicio)) {
                servicios.push(servicio);
              }
            });
          }
          return servicios;
        }, []);
  
        setServiciosDisponibles(serviciosUnicos);
    }
  }, [clientes, selectedClienteId]);

  useEffect(() => {
    if (selectedClienteId && clientes && clientes.length > 0) {
      const clienteSeleccionado = clientes.find(c => c.id === selectedClienteId);
      if (clienteSeleccionado && clienteSeleccionado.urlGrcFront) {
        setUrlGrcFront(clienteSeleccionado.urlGrcFront);
      }
    }
  }, [selectedClienteId, clientes]);

  const fetchNormativasPaginadas = useCallback(() => {
    setIsLoadingNormativas(true);
    
    const filtros = {
      searchTerm: searchTerm,
      organismo: selectedFilters.organismo?.nombre || null, 
      tipoDocumento: selectedFilters.tipoDocumento?.nombre || null,
      estadoTramitacion: selectedFilters.estadoTramitacion?.nombre || null,
      cliente: filterCliente !== 'todos' ? filterCliente : null,
      rubro: selectedFilters.rubro?.nombre || null,
      fechaDesde: startDate,
      fechaHasta: endDate
    };
    
    getNormativasClienteNoEnviadasPaginado(token, idUsuario, page + 1, rowsPerPage, filtros)
      .then((response) => {        
        if (!response) {
          setDocumentos([]);
          setTotalCount(0);
          return;
        }
        
        if (response.items && Array.isArray(response.items)) {
          setDocumentos(response.items);
          setTotalCount(response.totalCount || 0);
        } else {
          setDocumentos([]);
          setTotalCount(0);
        }
      })
      .catch((error) => {
        console.error("Error al cargar normativas:", error);
        setDocumentos([]);
        setTotalCount(0);
      })
      .finally(() => {
        setIsLoadingNormativas(false);
        setInitialLoadComplete(true);
      });
  }, [page, rowsPerPage, searchTerm, filterCliente, selectedFilters, startDate, endDate, token, idUsuario]);

  useEffect(() => {
    fetchNormativasPaginadas();
  }, [fetchNormativasPaginadas]);

  const handleFilterChange = (field, value) => {
    setSelectedFilters(prev => ({
      ...prev,
      [field]: value
    }));
    setPage(0);
  };

  const fetchClientes = () => {
    getClientesUsuario(token, idUsuario)
      .then((response) => {
        if (response && Array.isArray(response)) {
          setClientes(response);
        } else {
          setClientes([]);
        }
      })
      .catch((error) => {
        setClientes([]);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Manejadores de selección
  const handleSelectNormativa = (normativaId) => {
    setSelectedNormativas(prev => {
      if (prev.includes(normativaId)) {
        return prev.filter(id => id !== normativaId);
      } else {
        return [...prev, normativaId];
      }
    });
  };

  const handleSelectAllOnPage = () => {
    if (selectAll) {
      // Deseleccionar todas las de la página actual
      const currentPageIds = documentos.map(doc => doc.id);
      setSelectedNormativas(prev => prev.filter(id => !currentPageIds.includes(id)));
      setSelectAll(false);
    } else {
      // Seleccionar todas las de la página actual
      const currentPageIds = documentos.map(doc => doc.id);
      setSelectedNormativas(prev => {
        const newSelected = [...prev];
        currentPageIds.forEach(id => {
          if (!newSelected.includes(id)) {
            newSelected.push(id);
          }
        });
        return newSelected;
      });
      setSelectAll(true);
    }
  };

  const handleClearSelection = () => {
    setSelectedNormativas([]);
    setSelectAll(false);
  };

  // Función para enviar normativas a GRC
  const enviarNormativasGRC = async (normativasIds, clienteId) => {
    try {
      const result = await importacionMasivaDocumentos(token, normativasIds, clienteId);
      return result;
    } catch (error) {
      throw error;
    }
  };

  const handleOpenConfirmDialog = () => {
    if (selectedNormativas.length === 0) {
      setSendError("Debe seleccionar al menos una normativa para enviar");
      return;
    }
    
    if (!selectedClienteId) {
      setSendError("Debe seleccionar un cliente destino");
      return;
    }
    
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleSendToGRC = async () => {
    setOpenConfirmDialog(false);
    setIsSending(true);
    setSendError(null);
    setSendSuccess(false);

    // Validar que haya un cliente seleccionado
    if (!selectedClienteId) {
      setSendError("Debe seleccionar un cliente destino");
      setIsSending(false);
      return;
    }

    try {
      const result = await enviarNormativasGRC(selectedNormativas, selectedClienteId);
      
      if (result.success) {
        setSendSuccess(true);
        setSendError(null);
        
        // Limpiar selección después de envío exitoso
        setTimeout(() => {
          handleClearSelection();
          setSendSuccess(false);
          fetchNormativasPaginadas();
        }, 2000);
      } else {
        setSendError(result.message || "Error al enviar normativas");
        setSendSuccess(false);
      }
    } catch (error) {
      setSendError(error || "Error al enviar normativas");
      setSendSuccess(false);
    } finally {
      setIsSending(false);
    }
  };

  const getSemaforoColor = (cantidad, semaforoInfo, clienteId, tipoServicio = 'Obligaciones') => {
    if (semaforoInfo && semaforoInfo[clienteId] && semaforoInfo[clienteId].tieneConfiguracion) {
      const config = semaforoInfo[clienteId];
      
      // Verificar si el semáforo aplica a este tipo de servicio
      if (config.tipoAplicacion === tipoServicio || config.tipoAplicacion === 'Ambos') {
        // Retornar el color calculado desde el backend
        return tipoServicio === 'Compromisos' ? config.colorCompromisos : config.colorObligaciones;
      }
    }
    
    // Fallback a la lógica original si no hay configuración de semáforo
    if (cantidad === 0) return theme.palette.success.main;
    if (cantidad <= 2) return theme.palette.warning.main;
    return theme.palette.error.main;
  };

  const renderSemaforoObligaciones = (cantidadObligaciones, documento) => {
      const clienteId = documento.clientes && documento.clientes.length > 0 
        ? documento.clientes[0].id 
        : null;
      if (documento.semaforoInfo && documento.semaforoInfo[clienteId] && 
          documento.semaforoInfo[clienteId].tieneConfiguracion) {
        const config = documento.semaforoInfo[clienteId];
  
        // Solo mostrar semáforo si aplica a obligaciones
        if (config.tipoAplicacion === 'Obligaciones' || config.tipoAplicacion === 'Ambos') {
          const color = getSemaforoColor(cantidadObligaciones, documento.semaforoInfo, clienteId, 'Obligaciones');
          
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              <FiberManualRecordIcon 
                sx={{ 
                  color: color,
                  fontSize: '1rem'
                }} 
              />
              <Typography variant="body2">
                {cantidadObligaciones}
              </Typography>
            </Box>
          );
        }
      }
      return(
        <Typography variant="body2">
          {cantidadObligaciones}
        </Typography>
      )
    };
  
    // Función para renderizar el semáforo de compromisos
    const renderSemaforoCompromisos = (cantidadCompromisos, documento) => {
      const clienteId = documento.clientes && documento.clientes.length > 0 
        ? documento.clientes[0].id 
        : null;
        
      if (documento.semaforoInfo && documento.semaforoInfo[clienteId] && 
          documento.semaforoInfo[clienteId].tieneConfiguracion) {
        const config = documento.semaforoInfo[clienteId];
        
        // Solo mostrar semáforo si aplica a compromisos
        if (config.tipoAplicacion === 'Compromisos' || config.tipoAplicacion === 'Ambos') {
          const color = getSemaforoColor(cantidadCompromisos, documento.semaforoInfo, clienteId, 'Compromisos');
          
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              <FiberManualRecordIcon 
                sx={{ 
                  color: color,
                  fontSize: '1rem'
                }} 
              />
              <Typography variant="body2">
                {cantidadCompromisos}
              </Typography>
            </Box>
          );
        }
      }
      
      // Renderizado normal sin semáforo si no hay configuración o no aplica
      return (
        <Typography variant="body2">
          {cantidadCompromisos}
        </Typography>
      );
    };

  // Manejadores de filtros
  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0);
  };

  const handleClienteFilterChange = (e) => {
    setFilterCliente(e.target.value);
    setPage(0);
  };

  const handleStartDateChange = (newValue) => {
    setStartDate(newValue);
    setPage(0);
  };

  const handleEndDateChange = (newValue) => {
    setEndDate(newValue);
    setPage(0);
  };

  const handleResetFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSearchTerm("");
    setFilterCliente("todos");
    
    setSelectedFilters({
      organismo: null,
      tipoDocumento: null,
      estadoTramitacion: null,
      rubro: null,
    });
    
    setPage(0);
  };

  // Verificar si una normativa está seleccionada
  const isSelected = (id) => selectedNormativas.includes(id);

  // Contar normativas seleccionadas en la página actual
  const selectedCountOnPage = useMemo(() => {
    const currentPageIds = documentos.map(doc => doc.id);
    return selectedNormativas.filter(id => currentPageIds.includes(id)).length;
  }, [selectedNormativas, documentos]);

  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ width: "100%" }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron normativas con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );

  // Definir columnas para la tabla
  const tableColumns = useMemo(() => {
    const baseColumns = [
      { 
        id: 'select', 
        label: (
          <Checkbox
            checked={selectAll && selectedCountOnPage === documentos.length}
            indeterminate={selectedCountOnPage > 0 && selectedCountOnPage < documentos.length}
            onChange={handleSelectAllOnPage}
          />
        ), 
        minWidth: 50, 
        align: 'center' 
      },
      { id: 'nombre', label: 'Nombre', minWidth: 200, maxWidth: 300 },
      { id: 'organismoEmisor', label: 'Organismo', minWidth: 120, hideOnBreakpoint: 'md' },
      { id: 'tipoDocumento', label: 'Tipo', minWidth: 120, hideOnBreakpoint: 'md' },
      { id: 'estadoTramitacion', label: 'Estado', minWidth: 120 },
      { id: 'fechaPublicacion', label: 'Fecha Publicación', minWidth: 100, 
        format: (value) => value ? new Date(value).toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }) : '' 
      },
    ];

    if (multipleClients) {
      baseColumns.push({
        id: 'clientes', 
        label: 'Clientes', 
        minWidth: 150,
        hideOnBreakpoint: 'md',
        format: (value) => value && Array.isArray(value) 
          ? value.map(cliente => cliente.nombre).join(', ') 
          : ''
      });
    }

    if (serviciosDisponibles.includes('Compromisos')) {
      baseColumns.push({
        id: 'compromisos',
        label: 'Compromisos',
        minWidth: 100,
        align: 'center',
        hideOnBreakpoint: 'md',
        format: (value, documento) => renderSemaforoCompromisos(
          value && Array.isArray(value) ? value.length : 0,
          documento
        )
      });
    }

    if (serviciosDisponibles.includes('Obligaciones')) {
      baseColumns.push({
        id: 'obligaciones',
        label: 'Obligaciones',
        minWidth: 110,
        align: 'center',
        hideOnBreakpoint: 'md',
        format: (value, documento) => renderSemaforoObligaciones(
          value && Array.isArray(value) ? value.length : 0,
          documento
        )
      });
    }

    return baseColumns;
  }, [multipleClients, selectAll, selectedCountOnPage, documentos.length]);

  // Filtrar columnas según el tamaño de pantalla
  const visibleColumns = useMemo(() => 
    tableColumns.filter(column => {
      if (column.hideOnBreakpoint === 'md' && isSmall) return false;
      return true;
    }), 
  [tableColumns, isSmall]);

  // Renderizar las tarjetas para móviles
  const renderMobileCard = (documento) => (
    <Card 
      key={documento.id} 
      sx={{ 
        mb: 2,
        border: isSelected(documento.id) ? `2px solid ${theme.palette.primary.main}` : 'none',
        backgroundColor: isSelected(documento.id) ? theme.palette.action.selected : 'inherit'
      }}
    >
      <CardContent sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
          <Checkbox
            checked={isSelected(documento.id)}
            onChange={() => handleSelectNormativa(documento.id)}
          />
          <Typography variant="h6" sx={{ 
            wordBreak: "break-word",
            fontSize: "1rem",
            flex: 1
          }}>
            {documento.nombre}
          </Typography>
        </Box>
        <Divider sx={{ my: 1 }} />
        
        <Grid container spacing={1}>          
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Estado:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.estadoTramitacion}
            </Typography>
          </Grid>
          
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Organismo:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.organismoEmisor}
            </Typography>
          </Grid>
          
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Tipo:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.tipoDocumento}
            </Typography>
          </Grid>
          
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Fecha:
            </Typography>
            <Typography variant="body2" gutterBottom>
              {documento.fechaPublicacion ? new Date(documento.fechaPublicacion).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }) : ''}
            </Typography>
          </Grid>
          
          {multipleClients && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Clientes:
              </Typography>
              <Typography variant="body2" gutterBottom>
                {documento.clientes && Array.isArray(documento.clientes) 
                  ? documento.clientes.map((cliente) => cliente.nombre).join(", ")
                  : ""}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
  
  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <DataLoaderCliente onDataLoaded={handleDataLoaded} />
      
      <Grid item>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5">
            Enviar Normativas a AustranetGRC
          </Typography>
          
          {urlGrcFront && (
            <Button
              variant="outlined"
              color="primary"
              endIcon={
                <Box 
                  component="img" 
                  src={LogoGRC} 
                  alt="GRC Logo" 
                  sx={{ height: 20, width: 'auto' }}
                />
              }
              onClick={() => window.open(`${urlGrcFront}/documentos/paginador`, '_blank')}
              sx={{ 
                textTransform: 'none',
                whiteSpace: 'nowrap'
              }}
            >
              Ir a
            </Button>
          )}
        </Box>
        
        {/* Alertas de éxito/error */}
        {sendSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            ✓ {selectedNormativas.length} normativa(s) enviadas exitosamente a la aplicación GRC
          </Alert>
        )}
        
        {sendError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setSendError(null)}>
            {sendError}
          </Alert>
        )}
      </Grid>
      
      {/* Sección de filtros */}
      <Grid item>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Filtros de búsqueda
          </Typography>
          <Grid 
            container 
            spacing={2} 
            alignItems="flex-start"
          >
            {/* Filtro por nombre */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                fullWidth
                label="Buscar por nombre"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleSearchTermChange}
              />
            </Grid>
            
            {/* Filtro por cliente */}
            {multipleClients && (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Cliente</InputLabel>
                  <Select
                    value={filterCliente}
                    onChange={handleClienteFilterChange}
                    label="Cliente"
                  >
                    <MenuItem value="todos">Todos</MenuItem>
                    {clientes && Array.isArray(clientes) && clientes.map((cliente) => (
                      <MenuItem key={cliente.id} value={cliente.nombre}>
                        {cliente.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            
            {/* Organismo emisor */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.organismos || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Organismo emisor" size="small" />}
                  value={selectedFilters.organismo}
                  onChange={(event, newValue) => handleFilterChange("organismo", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>
            
            {/* Tipo de documento */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.tiposDocumento || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Tipo de documento" size="small" />}
                  value={selectedFilters.tipoDocumento}
                  onChange={(event, newValue) => handleFilterChange("tipoDocumento", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>
            
            {/* Estado de tramitación */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.estadosTramitacion || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Estado de tramitación" size="small" />}
                  value={selectedFilters.estadoTramitacion}
                  onChange={(event, newValue) => handleFilterChange("estadoTramitacion", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>
            
            {/* Rubros */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <FormControl fullWidth size="small">
                <Autocomplete
                  options={loadedData.rubros || []}
                  getOptionLabel={(option) => option.nombre || ""}
                  renderInput={(params) => <TextField {...params} label="Rubro" size="small" />}
                  value={selectedFilters.rubro}
                  onChange={(event, newValue) => handleFilterChange("rubro", newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                />
              </FormControl>
            </Grid>

            {/* Fecha desde */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  sx={{ width: "100%" }}
                  format="dd/MM/yyyy"
                  label="Fecha Desde"
                  value={startDate}
                  onChange={handleStartDateChange}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Grid>
            
            {/* Fecha hasta */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  sx={{ width: "100%" }}
                  format="dd/MM/yyyy"
                  label="Fecha Hasta"
                  value={endDate}
                  onChange={handleEndDateChange}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Grid>
            
            {/* Botones de acción */}
            <Grid item xs={12} container spacing={1} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={4} md={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={handleResetFilters}
                  size="small"
                >
                  Limpiar filtros
                </Button>
              </Grid>
              
              {/* Selector de cliente destino (si hay múltiples clientes) */}
              {multipleClients && (
                <Grid item xs={12} sm={4} md={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Cliente Destino</InputLabel>
                    <Select
                      value={selectedClienteId || ''}
                      onChange={(e) => setSelectedClienteId(e.target.value)}
                      label="Cliente Destino"
                      required
                    >
                      {clientes && clientes.map((cliente) => (
                        <MenuItem key={cliente.id} value={cliente.id}>
                          {cliente.nombre}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
              
              <Grid item xs={12} sm={4} md={3}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={handleOpenConfirmDialog}
                  startIcon={isSending ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                  disabled={isSending || selectedNormativas.length === 0}
                  size="small"
                >
                  {isSending ? 'Enviando...' : `Enviar a AustranetGRC (${selectedNormativas.length})`}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      
      {/* Sección de tabla/tarjetas según tamaño de pantalla */}   
      <Grid item>
        <Box mb={2} display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
            {selectedNormativas.length > 0 && (
                <Chip 
                  label={`${selectedNormativas.length} seleccionadas`}
                  color="primary"
                  onDelete={handleClearSelection}
                  deleteIcon={<ClearIcon />}
                />
              )}
        </Box>
        {(!initialLoadComplete || isLoadingNormativas) ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : documentos && documentos.length > 0 ? (
          <>
            {/* Vista de tarjetas para móviles */}
            {isMobile ? (
              <Box sx={{ mt: 2 }}>
                {documentos.map(renderMobileCard)}
              </Box>
            ) : (
              /* Vista de tabla para pantallas medianas y grandes */
              <TableContainer component={Paper} sx={{ overflow: "auto" }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      {visibleColumns.map((column) => (
                        <TableCell 
                          key={column.id} 
                          align={column.align || 'left'}
                          sx={{ 
                            minWidth: column.minWidth,
                            padding: '10px 8px',
                            whiteSpace: 'nowrap',
                            fontWeight: 'bold'
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {documentos.map((documento) => {
                      const selected = isSelected(documento.id);
                      return (
                        <TableRow 
                          key={documento.id}
                          hover
                          onClick={() => handleSelectNormativa(documento.id)}
                          selected={selected}
                          sx={{
                            cursor: 'pointer',
                            '&.Mui-selected': {
                              backgroundColor: theme.palette.action.selected,
                            },
                            '&.Mui-selected:hover': {
                              backgroundColor: theme.palette.action.hover,
                            },
                          }}
                        >
                          {visibleColumns.map((column) => {
                            if (column.id === 'select') {
                              return (
                                <TableCell 
                                  key={column.id} 
                                  align={column.align || 'center'}
                                  padding="checkbox"
                                >
                                  <Checkbox
                                    checked={selected}
                                    onChange={() => handleSelectNormativa(documento.id)}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                </TableCell>
                              );
                            }
                            
                            const value = documento[column.id];
                            return (
                              <TableCell 
                                key={column.id} 
                                align={column.align || 'left'}
                                sx={{ 
                                  padding: '8px',
                                  maxWidth: column.id === 'nombre' ? '250px' : '150px',
                                  whiteSpace: "nowrap", 
                                  overflow: "hidden", 
                                  textOverflow: "ellipsis"
                                }}
                              >
                                {column.format ? column.format(value, documento) : value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            
            {/* Paginación común para ambas vistas */}
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
          </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>
      
      {/* Dialog de confirmación */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
      >
        <DialogTitle>Confirmar envío a GRC</DialogTitle>
        <DialogContent>
          <Typography gutterBottom>
            ¿Está seguro que desea enviar {selectedNormativas.length} normativa(s) a la aplicación GRC?
          </Typography>
          {multipleClients && selectedClienteId && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Cliente destino: <strong>{clientes.find(c => c.id === selectedClienteId)?.nombre}</strong>
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Esta acción creará los documentos en el sistema de AustranetGRC.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="inherit">
            Cancelar
          </Button>
          <Button 
            onClick={handleSendToGRC} 
            color="primary" 
            variant="contained" 
            autoFocus
            disabled={!selectedClienteId}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default IntegracionGRCNormativas;